import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { getHTML } from '../../../services/commonFunction';

function ProductCard({data}) {
  const contentData = useSelector(state => state.Data.contentData);
  const langPrefix = useSelector(state => state.Data.langPrefix);
  return (
    <div className='relative group shadow-hover-parent cursor-pointer  transition-all duration-[0.5s]'>
        <div className='w-full h-[400px] max-[1800px]:h-[350px] max-[1400px]:h-[300px] shadow-hover-child  rounded-[0px] overflow-hidden relative'>
          <img className='w-full h-full rounded-[0px] group-hover:scale-[1.2] transition-all duration-[0.5s]' src={data?.image_full_url} />
          <div className='w-full h-full bg-black/30 absolute top-0 left-0 flex items-end'>
            <Link className='inline-block mt-[8px] min-w-[138px] transition-all mb-[20px] ml-[20px] duration-[0.5s] hover:bg-[var(--red)] p-[10px_22px] text-[15px] text-white bg-[#888888] rounded-[6px] font-[600]' to={`/${langPrefix}product/${data?.path}`}>{contentData?.read_more} →</Link>
           
          </div>
        </div>
        <div className='py-[10px] flex justify-between items-start gap-[20px]'>
          <div className=''>
              <h3 className='text-black text-[20px] font-[700]'>{data?.translate?.title}</h3>
              {/* <p className='text-black mt-[5px] text-[15px]'>{getHTML(data?.translate?.description)?.replaceAll("&nbsp;","")?.replaceAll("&nbsp","")?.substring(0,50)}...</p> */}
            </div>
        </div>
    </div>
  )
 }

export default ProductCard